import { Divider, Grid, makeStyles, Paper, Tab, Tabs } from "@material-ui/core";
import React from "react";
import PaymentHistoryTabView from "./payment-history-tab-view";
import SubscriptionAttemptTabView from "./subscription-attempts";
import FollowupCommentsTabView from "./follwup-comments-tab-view";
import { useContext } from "react";
import { UserListAdvertisementContext } from "../../../../../../../context/follow-up-widgets";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

const DetailedMenuView = () => {
  const { advertisement } = useContext(UserListAdvertisementContext);

  const isPaymentPendingAd = advertisement.post?.status === "PAYMENT_PENDING";

  const classes = useStyles();
  const [activeTab, setActiveTab] = React.useState(isPaymentPendingAd ? 2 : 0);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Grid item container direction="column" className="detailed-menu-view">
      <Divider />
      <Paper className={classes.root} elevation={0} classes="menu-paper">
        <Tabs
          value={activeTab}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          <Tab label="payment history" disabled={isPaymentPendingAd} />
          <Tab label="subscription attempts" disabled={isPaymentPendingAd} />
          <Tab label="follw up comments" />
        </Tabs>
      </Paper>
      {activeTab === 0 && <PaymentHistoryTabView />}
      {activeTab === 1 && <SubscriptionAttemptTabView />}
      {activeTab === 2 && <FollowupCommentsTabView />}
    </Grid>
  );
};

export default DetailedMenuView;
